// extracted by mini-css-extract-plugin
export default {"parent":"formSelect_parent__PW1Bl","parentErrorInform":"formSelect_parentErrorInform__UBOGt"};